import React, { useEffect, useState } from "react"

import {
   CommitWarehouseAuditItems,
   GetBulkCommitAuditItemsSummary,
} from "api/api.service"
import { Button } from "components/Button"
import { DataTable } from "components/DataTable"
import { Modal } from "components/Modal"
import ConfirmationModal from "pages/Configurator/Trailers/ConfirmationModal"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import ModalListingSkeleton from "../CountSheetSkeleton/ModalListingSkeleton"
import toast from "react-hot-toast"
import docIcon from "../../../../assets/images/gyft-icons/paper.png"

const COLUMNS = {
   SKU_NO: "SKU No.",
   WAREHOUSE: "Warehouse",
   DATE: "Date",
   TIME: "Time",
   ITEM_NAME: "Item Name",
   AUDIT_QUANTITY: "Audit Quantity",
}
const WarehouseBulkCommitDetailModal = ({
   isOpen,
   toggleFunction,
   selectedItemsData,
   WarehouseIds,
   request = () => {},
}) => {
   const [modalState, setModalState] = useState(false)
   const [auditHistoryData, setAuditHistoryData] = useState([])
   const [isloading, setIsLoading] = useState(false)

   useEffect(() => {
      setIsLoading(true)
      const payload = {
         itemsIds: selectedItemsData.map(item => item?.itemsId),
         ...(WarehouseIds.length > 0 && {
            warehouseIds: WarehouseIds.map(id => id),
         }),
      }
      GetBulkCommitAuditItemsSummary(payload)
         .then(res => {
            setAuditHistoryData(res?.data)
            setIsLoading(false)
         })
         .catch(err => {
            console.error(err)
         })
   }, [selectedItemsData])

   const handleWarehouseBulkCommit = async () => {
      const payload = {
         itemsIds: selectedItemsData.map(item => item?.itemsId),
         ...(WarehouseIds.length > 0 && {
            warehouseIds: WarehouseIds.map(id => id),
         }),
      }

      try {
         setIsLoading(true)
         await CommitWarehouseAuditItems(payload)
         toast.success("Warehouse bulk items has been committed successfully !")
         request()
         toggleFunction()
         handleCloseModal()
      } catch (error) {
         console.log(error)
      } finally {
         setIsLoading(false)
      }
   }

   const handleConfirmationModal = () => {
      setModalState(prev => !prev)
   }
   const handleCloseModal = () => {
      setModalState(false)
   }

   return (
      <>
         <Modal
            isOpen={isOpen}
            handleModalToggling={toggleFunction}
            bodyClassName="px-5"
            customButton={true}
            hideModalHeaderSeparator={true}
            headerClasses="header-container mb-0 pt-5"
            size="lg"
            backdrop="static"
            sizeClasses={"7"}
            scrollable
         >
            {auditHistoryData.length === 0 && !isloading ? (
               <div
                  style={{
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                     height: "50vh",
                     textAlign: "center",
                     color: "#555",
                  }}
               >
                  <div style={{ marginBottom: "16px" }}>
                     <img
                        src={docIcon}
                        alt="No items"
                        height={"100px"}
                        width={"100px"}
                     />
                  </div>
                  <div
                     style={{
                        fontSize: "14px",
                        color: "black",
                        fontWeight: "bold",
                     }}
                  >
                     No recent audit entries found for selected items.
                  </div>
               </div>
            ) : isloading && !modalState ? (
               <ModalListingSkeleton />
            ) : (
               <div className="mb-5 ">
                  <div className=" justify-content-end d-flex">
                     <Button
                        isLoading={isloading}
                        title={"Bulk Commit"}
                        type={"submit"}
                        className="list-commit-button mb-3 align-items-center"
                        size={"lg"}
                        onClick={handleConfirmationModal}
                     />
                  </div>

                  <DataTable
                     data={auditHistoryData}
                     loading={isloading}
                     config={[
                        {
                           title: COLUMNS.SKU_NO,
                           render: item => item?.item?.skuNo,
                        },
                        {
                           title: COLUMNS.ITEM_NAME,
                           render: item => item?.item?.itemName,
                        },
                        {
                           title: COLUMNS.WAREHOUSE,
                           render: item => item?.warehouse?.warehouseName,
                        },
                        {
                           title: COLUMNS.AUDIT_QUANTITY,
                           render: item => item?.newQuantity,
                        },
                        {
                           title: COLUMNS.DATE,
                           render: data =>
                              convertDateTime({
                                 date: data.updatedAt,
                                 customFormat:
                                    dateTimeFormat.casitaCustomDateFormatOnly,
                                 dateOnly: true,
                                 local: true,
                              }),
                        },
                        {
                           title: COLUMNS.TIME,
                           render: data =>
                              convertDateTime({
                                 date: data.updatedAt,
                                 customFormat: dateTimeFormat.onlyTimeFormat,
                                 dateOnly: true,
                                 local: true,
                              }),
                        },
                     ]}
                  />
               </div>
            )}
         </Modal>
         <ConfirmationModal
            isOpen={modalState}
            actionName="Save"
            entityName="Bulk Commit"
            toggleFunction={handleCloseModal}
            handleYes={handleWarehouseBulkCommit}
            isLoading={isloading}
         />
      </>
   )
}

export default WarehouseBulkCommitDetailModal
